import React from "react";

import styles from "../../JobShiftPreStart/JobShiftPreStartView.module.css";

export default function EmergencyPlanContactsSection({ section, sectionNumber = 4 }) {
  const data = section && section.data ? section.data : {};
  const displayName = section && section.display_name ? section.display_name : "Emergency Contacts";
  const types = Array.isArray(data.types)
    ? data.types.filter((type) => type && type.toggle === 1)
    : [];
  const rows = types.reduce((result, type) => {
    const contacts = Array.isArray(type.contacts)
      ? type.contacts.filter((contact) => contact && [contact.contact_name, contact.phone_number]
        .some((value) => String(value || "").trim() !== ""))
      : [];

    result.push({ type, contacts });
    return result;
  }, []);

  return (
    <div className={styles.PreviewSectionBlock}>
      <div className={styles.PreviewSectionHead}>
        <span className={`${styles.PreviewSectionNum} ${styles.PreviewSectionNumPreview}`} style={{ background: "#e9c84a", color: "#1f1031" }}>
          {sectionNumber}
        </span>
        {displayName}
      </div>
      <div className={styles.PreviewSectionBody}>
        <table className={`${styles.PreviewTable} ${styles.EmergencyPlanScenarioTable}`}>
          <thead className={styles.EmergencyPlanScenarioTableHead}>
            <tr>
              <th style={{ width: "65%" }}>Contact / Service Name</th>
              <th style={{ width: "35%" }}>Phone Number</th>
            </tr>
          </thead>
          <tbody>
            {rows.length > 0 ? rows.map(({ type, contacts }, typeIndex) => (
              <React.Fragment key={type.id || typeIndex}>
                <tr className={styles.EmergencyTypeRow}>
                  <td colSpan={2}><strong>{type.emergency_type || ""}</strong></td>
                </tr>
                {contacts.map((contact, contactIndex) => (
                  <tr key={contact.id || contactIndex}>
                    <td>{contact.contact_name || ""}</td>
                    <td>{contact.phone_number || ""}</td>
                  </tr>
                ))}
              </React.Fragment>
            )) : (
              <tr>
                <td colSpan={2}>No emergency contacts available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
